import { styled } from '@mui/material';

import { tokens } from '@cast/design-system';

import { TendencyIndicatorBase } from './_components';

export const TendencyIndicator = styled(TendencyIndicatorBase)({
  width: 'max-content',
  paddingLeft: '7px',
  paddingRight: '7px',
  borderRadius: '20px',
  '&.Tendency-up': {
    backgroundColor: tokens.theme.bg.status.errorStrong,
    '&& .TendencyIndicator-icon, && .TendencyIndicator-label': {
      color: tokens.theme.fg.status.onErrorStrong,
    },
  },
  '&.Tendency-down': {
    backgroundColor: tokens.theme.bg.status.successStrong,
    '&& .TendencyIndicator-icon, && .TendencyIndicator-label': {
      color: tokens.theme.fg.status.onSuccessStrong,
    },
  },
  '&.Tendency-stable': {
    backgroundColor: tokens.theme.bg.status.neutralSubtle,
    '&& .TendencyIndicator-icon, && .TendencyIndicator-label': {
      color: tokens.theme.fg.status.onNeutralSubtle,
    },
  },
});
